import React, { useState } from 'react'
import { IncomingTransactionsTableContainer } from '../transactions/incomingtransactions/IncomingTransactionsTableContainer'
import { useCorrectionElements } from './getcorrectionviewelements'

const CorrectionContainer = ({ incomingTransactions, setAlertMessage, setModalTitle, setModalDescription, setTransactionSysId, setTransactionState, openAlert, setShowConfirmationModel }) => {
    const [newCorrections, setNewCorrections] = useState([])
    const [correctionAmounts, setCorrectionAmounts] = useState([])

    const [corrections, setCorrections] = useState([])
    const { correctionRefs, getCorrectionInputFields, getNewCorrectionValues } = useCorrectionElements()

    /**
     * Opens a correction line containing already saved or new corrections added to a transaction.
     * @param {string} transactionSysId
     * @param {string} articleSysId
     */
    const openCorrectionLine = (transactionSysId, articleSysId) => {
        const uniqueCorrectionId = transactionSysId + "__" + articleSysId
        if (corrections.includes(uniqueCorrectionId)) {
            setCorrections(corrections.filter(item => item !== uniqueCorrectionId))
            correctionRefs.current = correctionRefs.current.filter(item => item.value !== null)
        } else {
            const newCorrections = [...corrections]
            newCorrections.push(uniqueCorrectionId)
            setCorrections(newCorrections)
        }
    }

    /**
     * Adds a new correction for the selected ArticleType
     * @param {string} transactionSysId
     * @param {string} articleSysId
     * @param {object[]} sizeEntries array with sizeValues and amounts
     * @param {object} article not used atm
     */
    function addNewCorrectionForArticleType(transactionSysId, articleSysId, sizeEntries, article) {
        let invalid = false

        if (sizeEntries.every(x => (x.Amount + parseInt(correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + x.SizeValue].value)) >= 0)) {
            invalid = false
        } else {
            invalid = true
        }

        if (invalid == false) {
            const uniqueCorrectionId = transactionSysId + "__" + articleSysId
            const newCorrection = [...newCorrections]
            newCorrection.push(uniqueCorrectionId)
            setNewCorrections(newCorrection)

            const newCorrectionAmounts = [...correctionAmounts]

            sizeEntries.forEach(x => {
                newCorrectionAmounts.push({ name: (transactionSysId + "__" + articleSysId + "__" + x.SizeValue), value: correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + x.SizeValue].value })
                x.NewCorrectionAmount = correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + x.SizeValue].value
            })

            setCorrectionAmounts(newCorrectionAmounts)

            const transactionWithNewCorrection = incomingTransactions.filter(x => x.TransactionSysId == transactionSysId)[0]
            if (transactionWithNewCorrection != null) transactionWithNewCorrection.StateCorrected = "_corrected"
        } else {
            setAlertMessage(window.i18n('errorCorrectionValues'))
            openAlert()
        }
    }

    /**
     * Shows a confirmation modal based on the actual state of the transaction.
     * @param {string} transactionSysId
     * @param {string} transactionState state of the transaction
     * @param {boolean} stateCorrectedBool indicates if a transaction already was corrected
     */
    function handleShowConfirmationModal(transactionSysId, transactionState, stateCorrectedBool) {
        setShowConfirmationModel(true)
        setTransactionSysId(transactionSysId)
        setTransactionState(stateCorrectedBool == true ? "_corrected" : transactionState)

        if (stateCorrectedBool == true) {
            setModalTitle(window.i18n('submitCorrection'))
            setModalDescription(window.i18n('submitCorrection2'))
        }

        else if (transactionState == "InProcess") {
            setModalTitle(window.i18n('submitDelivery'))
            setModalDescription(window.i18n('submitDelivery2'))
        }
        else if (transactionState == "InTransit") {
            setModalTitle(window.i18n('submitDeliveryIncome'))
            setModalDescription(window.i18n('submitDeliveryIncome2'))
        }
        else if (transactionState == "Arrived") {
            setModalTitle(window.i18n('submitEditing'))
            setModalDescription(window.i18n('submitEditing2'))
        }
    }

    return (
        <IncomingTransactionsTableContainer
            incomingTransactions={incomingTransactions} handleShowConfirmationModal={handleShowConfirmationModal}

            newCorrections={newCorrections} corrections={corrections} addNewCorrectionForArticleType={addNewCorrectionForArticleType} openCorrectionLine={openCorrectionLine}
            getCorrectionInputFields={getCorrectionInputFields} getNewCorrectionValues={getNewCorrectionValues}
        />
        )
}

export { CorrectionContainer}